import React from 'react'
import moment from 'moment'

export default function Moment(props) {

    const {date} = props    
    moment.locale('sr')
    
    return <time>{moment(date).calendar()}</time> 
}